export const HomeTrust = () => {
  return (
    <section className="bg home-trust">
      <div className="container">
        <div className="row">
          <div className="col-lg-7">
            <div className="trust__left">
              <h2 className="section__title text--black">@@title</h2>
              <p className="section__desc text--gray">@@desc</p>
              <div className="d-flex align-items-center trust__counter">
                <div className="item">
                  <p className="text--bold text--black number">
                    @@counter_1.number <span className="text--darkBlue">+</span>
                  </p>
                  <p className="text--regular text--gray title">
                    @@counter_1.title
                  </p>
                </div>
                <div className="item">
                  <p className="text--bold text--black number">
                    @@counter_2.number <span className="text--darkBlue">+</span>
                  </p>
                  <p className="text--regular text--gray title">
                    @@counter_2.title
                  </p>
                </div>
                <div className="item">
                  <p className="text--bold text--black number">
                    @@counter_3.number <span className="text--darkBlue">+</span>
                  </p>
                  <p className="text--regular text--gray title">
                    @@counter_3.title
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-5">
            <div className="row">
              <div className="col-6">
                <figure className="trust__image">
                  <img
                    className="img-fluid"
                    src="@@img_1.src"
                    alt="@@img_1.alt"
                  />
                </figure>
              </div>
              <div className="col-6">
                <figure className="trust__image">
                  <img
                    className="img-fluid"
                    src="@@img_2.src"
                    alt="@@img_2.alt"
                  />
                </figure>
              </div>
              <div className="col-6">
                <figure className="trust__image mb-md-0">
                  <img
                    className="img-fluid"
                    src="@@img_3.src"
                    alt="@@img_3.alt"
                  />
                </figure>
              </div>
              <div className="col-6">
                <figure className="trust__image mb-0">
                  <img
                    className="img-fluid"
                    src="@@img_4.src"
                    alt="@@img_4.alt"
                  />
                </figure>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
